
import { Typography, Checkbox, Box} from '@mui/material';


const CustomCheckBox = ({id, label, handleCheckboxChange, handleCheckedValue}) => {
    return (
        <Box display="flex" alignItems="center">
            <Checkbox id={id} style={{ cursor: 'pointer', color: '#604CC3' }}
                    checked={handleCheckedValue(label)} // Bind to some value if needed
                    onChange={(event) => handleCheckboxChange(event, id, label)} // Checkbox change handler
                    inputProps={{ 'aria-label': 'controlled' }}
                />
                <label htmlFor={id} style={{ cursor: 'pointer' }}>
                <Typography>
                    {label}
                </Typography>
            </label>
        </Box>
    )
}

export default CustomCheckBox;